exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#intercom-padding {\n  height: 60px;\n  margin-top: 20px;\n}\n", ""]);

// exports
